// src/api/produzione/assegnazioniGanttApi.ts

import { handleResponse, handleError, headerset } from "../apiUtils";
import { FiltriAssegnazioniGantt } from "components/main/produzione/ordiniLavoro/ordineLavoro/assegnazioni/gantt/assegnazioniGanttTypes";

// ============================================
// BASE URL
// ============================================

/**
 * URL per endpoint gantt assegnazioni
 * path('assegnazioni/gantt/<str:data_da>/<str:data_a>/')
 */
const baseUrlGantt = (data_da: string, data_a: string) => {
    return `${process.env.API_URL}/api/produzione/assegnazioni/gantt/${data_da}/${data_a}/`;
};

// ============================================
// QUERY STRING BUILDER
// ============================================

const buildQueryString = (filtri: Omit<FiltriAssegnazioniGantt, 'data_da' | 'data_a'>): string => {
    const params = new URLSearchParams();

    // Filtro tecniche (array)
    if (filtri.tecniche && filtri.tecniche.length > 0) {
        params.append('tecniche', filtri.tecniche.join(','));
    }

    return params.toString();
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Fetch lista assegnazioni per Gantt nel range di date
 */
export function fetchAssegnazioniGantt(filtri: FiltriAssegnazioniGantt) {
    let url = baseUrlGantt(filtri.data_da, filtri.data_a);

    const queryString = buildQueryString(filtri);
    if (queryString) {
        url += `?${queryString}`;
    }

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}